// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Disclaimer__container___1JxVR{display:flex;justify-content:center}.Disclaimer__inner___13PDP{max-width:1135px;margin:32px;border-radius:8px;background-color:#f4f3ef}@media (max-width:719px){.Disclaimer__inner___13PDP{margin:16px}}.Disclaimer__inner___13PDP .Disclaimer__text___22_5s{color:inherit;font-weight:400;font-size:14px;line-height:20px;padding:40px 128px;color:#96948a;text-align:center}@media (max-width:959px){.Disclaimer__inner___13PDP .Disclaimer__text___22_5s{padding:20px 64px}}@media (max-width:719px){.Disclaimer__inner___13PDP .Disclaimer__text___22_5s{padding:16px 24px;text-align:left;text-align:initial}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Disclaimer__container___1JxVR",
	"inner": "Disclaimer__inner___13PDP",
	"text": "Disclaimer__text___22_5s"
};
module.exports = ___CSS_LOADER_EXPORT___;
